<template lang="html">
  <div>
    <v-header backTo="Login profissional">
      <router-link :to="{ name: 'vibbrant-login' }" class="linkLogin">
        Sou profissional
      </router-link>
    </v-header>

    <v-page class="page-realise" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
      <div class="autoLogin">
        <v-login class="card-login">
          <div class="center">
            <div class="loginLeft">
              <div class="company">
                <p>E</p>
                <p>M</p>
                <p>P</p>
                <p>R</p>
                <p>E</p>
                <p>S</p>
                <p>A</p>
              </div>
              <div>
                <img class="photo" :src="img_url">
              </div>
            </div>
            <div class="loginRight">
              <div class="card-register">
              <div class="headerForm">

                    <img  src="static/logo.svg?v=1" alt="" />
                    <div tag="h2" class="h4 title center textBold">
                      Estamos quase lá!
                    </div>
                    <small>
                      <p class="paragaf">
                        Agora, só precisamos de algumas informações adicionais para entender
                        melhor sua demanda e agilizar nossa comunicação.
                      </p>
                    </small>

              </div>

                <div class="allInfo">

                  <div class="colLeft">
                      <v-row class="size-1">
                      <v-col :xs="12" :sm="12">
                        <label class="textBold">O que você procura?</label><br />
                        <v-input type="checkbox" id="what_want1" v-model="client.what_want1">
                          Contratar um profissional específico
                        </v-input><br />
                        <v-input type="checkbox" id="what_want2" v-model="client.what_want2">
                          Contratar uma equipe/squad
                        </v-input><br />
                        <v-input type="checkbox" id="what_want3" v-model="client.what_want3">
                          Ajuda para desenvolver o seu projeto
                        </v-input><br />
                        <v-input type="checkbox" id="what_want4" v-model="client.what_want4">
                          Ajuda com planejamento de projeto
                        </v-input><br />
                        <v-input type="checkbox" id="what_want5" v-model="client.what_want5">
                          Conhecer a plataforma Vibbra
                        </v-input><br />
                        <v-input type="checkbox" id="what_want6" v-model="client.what_want6">
                       Conhecer mais sobre o processo de seleção de Vibbrantes
                        </v-input><br />
                        <v-input type="checkbox" id="what_want7" v-model="client.what_want7">
                          Quero ser vibbrante
                        </v-input><br />
                      </v-col>
                    </v-row>





                  </div>

                  <div class="colRight">
                   <v-input type="text" v-model="client.company">
                      Nome da sua empresa
                    </v-input>
                    <v-input
                      type="select"
                      class="m-0"
                      v-model="client.origin"
                      :options="[
                        'Google',
                        'Blog',
                        'Indicação',
                        'Facebook',
                        'Instagram',
                        'Linkedin',
                        'Indicação de Cliente da Vibbra',
                        'Indicação de Amigo',
                        'Outro',
                      ]">
                      Como você conheceu a Vibbra?
                    </v-input>
                    <v-input
                      type="text"
                      v-model="client.origin_desc"
                      v-if="client.origin === 'Outro'">
                      Outro*
                    </v-input >
                      <v-input type="textarea" class="textArea" rows="5" v-model="client.what_want_comment">
                      Fale mais sobre sua demanda
                    </v-input>

                    <v-button class="primary" @click="save()">Enviar</v-button>
                   </div>

                  </div>
                  </div>



            </div>
          </div>
        </v-login>
      </div>
    </v-page>
  </div>
</template>


<script>
import clientApi from '@/api/client';

export default {
  data() {
    return {
      img_background_url: require('../../assets/background/fundoAzul.svg'),
      img_url: require('../../assets/photoPeople/Planos-Enterprise.png'),
      client: {
        company: '',
        what_want1: false,
        what_want2: false,
        what_want3: false,
        what_want4: false,
        what_want5: false,
        what_want6: false,
        what_want7: false,
        what_want_comment: '',
        origin: '',
        origin_desc: '',
      },
    };
  },
  methods: {
    save() {
      clientApi
        .clientReleaseAccess(this.client)
        .then(response => {
          if (response.status === 200) {
            if (response.data.release_register) {
              this.$store.dispatch('releaseRegister');
              this.$router.push({ name: 'client-dashboard' });
            } else {
              this.$notify('Verifique os campos obrigatórios', 'info');
            }
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>

<style lang="scss">
 .linkLogin{
     color: white !important;

  &:hover{
    color: #0377AA !important;
      text-decoration: none;
  }


    }
.registeHere{
  color: #0377AA !important;

  &:hover{
    color: #0377AA !important;
    text-decoration: none;
  }
}
.page {
    min-height: calc(100vh - 60px);
}
.page-realise {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;

  .autoLogin {
    width: 75%;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .card-login {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    justify-content: center;
    @include media-breakpoint-up(lg) {
      width: 100%;
    }
    .center {
      display: flex;
           align-items: flex-end;
      padding: 2rem 2rem 0 0;


      @include media-breakpoint-down(lg) {
        align-items: center;
        padding: 2rem;
      }
    }
    .loginLeft {
      display: flex;
      align-items: flex-end;


      width: 40%;
      @include media-breakpoint-down(lg) {
        display: none;
      }
    }

    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .loginRight {
      width: 60%;
      @include media-breakpoint-down(lg) {
        width: 100%;
      }
    }

    .textArea{
      margin-top: 30px;
    }

    .logo {
      height: 60px;
      text-align: center;
      margin: 0 0 30px 0;
    }


    .photo {
      height: 500px;
    }

    .textBold{
      font-weight:bold ;
    }

    .headerForm{
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      flex-direction: column;
      margin-bottom: 20px;

    }

    .allInfo{
      display: flex;
      gap: 2rem;
      margin-bottom: 20px;

       @include media-breakpoint-down(md){
        flex-direction: column;
        align-items: center;
        gap: 1rem;
       }
         @include media-breakpoint-down(md){
        width: 100%;
      }
    }

    .colLeft{
      width: 50%;

      @include media-breakpoint-down(md){
        width: 100%;
      }
    }
    .colRight{
      width: 50%;
      display: flex;
      flex-direction: column;

        @include media-breakpoint-down(md){
        width: 100%;
      }

    }

    .paragaf{
      font-size: 15px;
    }

    .titleLoginEmpresa{
      font-size: 45px;
      font-weight: bold;
      margin-bottom: 40px;
      text-align: center;

      @include media-breakpoint-down(md) {
        font-size: 35px;
      }
    }
    .dataRadio {
      display: flex;
      align-items: center;
    }
    .inputRadio {
      margin: 0 !important;
    }
    .helpers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
      }
    }
    .register {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 20px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
        text-align: center;
        gap: 0;
        p {
          margin: 0;
        }
      }
    }
  }
  footer.page-footer {
    color: white;
    margin-top: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/client-release-register.vue